import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";

const SupportPage = lazy(() => import("../pages/support/page"));
const CommercialPage = lazy(() => import("../pages/commercial/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/page"));
const PrivacyChoicesPage = lazy(() => import("../pages/privacy-choices/page"));
const AccessibilityPage = lazy(() => import("../pages/accessibility/page"));
const LinksPage = lazy(() => import("../pages/links/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/support",
    element: <SupportPage />,
  },
  {
    path: "/commercial",
    element: <CommercialPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/privacy-choices",
    element: <PrivacyChoicesPage />,
  },
  {
    path: "/accessibility",
    element: <AccessibilityPage />,
  },
  {
    path: "/links",
    element: <LinksPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
